import React, { useState, useEffect } from "react";
import {
  Grid,
  Divider,
  FormControl,
  NativeSelect,
  withStyles,
  InputBase,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
// componentes del sistema
import TablePaginatedPay from "widgets/Tables/TablePaginatedPay";
import TableSimple from "widgets/Tables/TableSimple";
import { API_GET_ALL_COMPANY, API_GET_SEARCH_COMPANY } from "./apis";
import { clientPay } from "configurations/axios";
import tableStyle from "configurations/styles/table";
import AddPartnerBtn from "./Buttons/AddPartner";
import SearchPartner from "./Froms/SearchPartner";
import EditCompanyBtn from "./Buttons/EditCompanyBtn";
import { tipoContratacion } from "./typeHiring";
import GenerateReportIssuedBtn from "../company/Buttons/GenerateReportIssuedBtn";
import { CardGeneric } from "../components/CardGeneric";
import AsignarComprobantes from "./Buttons/AsignarComprobantes";
import RegistrarComprobantes from "./Buttons/RegisterNewPacket";
import AddCompanyBtn from "./Buttons/AddCompanyBtn";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "35px",
    paddingBottom: "7%",
    flexGrow: 1,
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  headerBottons: {
    padding: "0.5%",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: "300px",
  },
}));

const Home = () => {
  const tokenUser = useSelector((state) => state.user.tk);

  const classesView = useStyles();
  const [update, setUpdate] = useState(0);
  const [foundCostumers, setFoundCostumers] = useState([]);
  const [paramSearch, setParamSearch] = useState("");
  const columns = [
    { title: "RUC", field: "idempresacontratante", cellStyle: tableStyle.cellTable, width: "8%", },
    { title: "Razón Social/Nombres", field: "razonSocialempresa", cellStyle: tableStyle.cellLeft, },
    { title: "Correo", field: "correo", cellStyle: tableStyle.cellLeft, },
    { title: "Fecha de Registro", field: "fechaRegistro", cellStyle: tableStyle.cellTable,  render: rowData => rowData.fechaRegistro.substring(0, 10) },
    { title: "Rep. Comp. Emitidos", cellStyle: tableStyle.cellTable, render: rowData => <GenerateReportIssuedBtn data={rowData} /> },
    { title: "# Comp. Emitidos", field: "comprobantesUtilizados", cellStyle: tableStyle.cellLeft, },
    { title: "# Comp. Disponibles", field: "comprobantesDisponibles", cellStyle: tableStyle.cellLeft, },
    { title: "Tipo Pago", field: "tipoContratacion", cellStyle: tableStyle.cellLeft, },
    // { title: "Editar", cellStyle: tableStyle.cellTable, render: rowData => <EditCompanyBtn data={rowData} reload={reload} /> },
];

  

  const getParam = (data) => {
    setParamSearch(data);
    if (data.length > 0) {
      searchCostumer(data);
    } else {
      reload();
    }
  };

  const requestConfig = {
    uri: API_GET_ALL_COMPANY+ (tokenUser ? getRUCEmpresa(tokenUser) : "0"),
    metodo: "get",
    body: null,
    page: 0,
    elementos: 15,
    sort: "fechaRegistro,desc",
  };

  const reload = () => {
    setUpdate(1);
  };

  useEffect(() => {
    if (update === 1) {
      setUpdate(0);
    }
  }, [update]);

  const searchCostumer = async (param) => {
    setUpdate(3);
    await clientPay
      .get(
        API_GET_SEARCH_COMPANY +
          getRUCEmpresa(tokenUser) +
          "?parametroBusqueda=" +
          param
      )
      .then((response) => {
        if (response.status === 200) {
          setFoundCostumers(response.data);
          setUpdate(2);
        }
      })
      .catch((exception) => {
        console.error({ exception });
      });
  };

  const renderTable = () => {
    switch (update) {
      case 0:
        return (
          <TablePaginatedPay
            title=""
            columns={columns}
            requestConfig={requestConfig}
          />
        );

      case 1:
      case 3:
        return (
          <div className={classesView.loader}>
            <CircularProgress />
          </div>
        );
      case 2:
        return (
          <TableSimple
            columns={columns}
            data={foundCostumers}
            title=""
            numberRowsPerPage={15}
          />
        );
      default:
        break;
    }
  };

  return (
    <div className={classesView.root}>
      <CardGeneric>
        <Grid container spacing={1}>
        <Grid item xs={12} md={12}>
            {<AddCompanyBtn updateView={reload} />}
          </Grid>
          <Grid item xs={12} md={12}>
            <AsignarComprobantes updateView={reload}></AsignarComprobantes>
          </Grid>
          {/* <Grid item xs={12} md={12}>
            <RegistrarComprobantes updateView={reload}></RegistrarComprobantes>
          </Grid> */}
          <Grid item xs={12} md={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={9} className={classesView.headerBottons}>
            <SearchPartner backupParam={paramSearch} sendData={getParam} />
          </Grid>
        </Grid>
      </CardGeneric>
      {renderTable()}{" "}
    </div>
  );
};

export default Home;
